import { apiPaths, envNames } from "./variables";

export const environment: any = {
    production: isProd(),
    // debugMode: isDebugMode(),
    debugMode: false,
    assets: "/assets",
    apiPath: apiPath(),
    envName: envName(),
    storagePrefix: storagePrefix(),
    flags: {
        customerMaster: true,
        dealTerms: true,
        products: true,
        audioConfigurationPresets: true,
    },
};

export const timeOutInactiveConfig: any = {
    INACTIVITY_TIMEOUT: 3600000 // Setting inactivity timeout in 1 hour.
};

export function envName() {
    if (checkEnv("localhost")) {
        return envNames.LOCAL;
    } else if (checkEnv("int")) {
        return envNames.DEV;
    } else if (checkEnv("qat")) {
        return envNames.QA;
    } else if (checkEnv("stg")) {
        return envNames.STAGING;
    } else {
        return envNames.PROD;
    }
}

export function storagePrefix() {
    return `app-isp.${envName()}.dmd.disney.com`;
}

export function apiPath() {
    return apiPaths[envName()] || apiPaths[envNames.LOCAL];
}

export function isProd() {
    return envName() === envNames.PROD;
}

export function isDebugMode() {
    return envName() !== envNames.PROD;
}

export function checkEnv(env: string) {
    const hostname = location.hostname;
    const match = hostname.match(env);
    return !!match ? match.index === 8 : false;
}
